import { render } from "./empty-helpdesk.vue?vue&type=template&id=da41231e&scoped=true"
const script = {}

import "./empty-helpdesk.vue?vue&type=style&index=0&id=da41231e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da41231e"]])

export default __exports__